import alert_mixin from '@/utils/mixins/alert_mixin';
import ConfigureDocusealTemplate from '@/views/config_views/EsigningManagment/ConfigureDocusealTemplate/ConfigureDocusealTemplate.vue';
import esigning_setup_computed from './esigning_setup_computed';
import esigning_setup_form_methods from './esigning_setup_form_methods';
import { create_esigning_setup_data } from './esigning_setup_helpers';
import esigning_setup_route_methods from './esigning_setup_route_methods';
import esigning_setup_workflow_methods from './esigning_setup_workflow_methods';

export default {
  name: 'EsigningSetup',
  mixins: [alert_mixin],
  components: {
    ConfigureDocusealTemplate,
  },
  data: create_esigning_setup_data,
  computed: esigning_setup_computed,

  mounted() {
    this.sync_context_from_route();
    this.load_template_forms();
    this.load_workflows();
  },

  watch: {
    '$route.query': {
      handler(new_query, old_query) {
        const previous_template_id = String(old_query?.template_id || '').trim();
        const next_template_id = String(new_query?.template_id || '').trim();

        if (previous_template_id !== next_template_id) {
          this.reset_template_setup_state();
          this.sync_context_from_route();
          this.load_template_forms();
          this.load_workflows();
          return;
        }

        this.sync_context_from_route();
      },
      deep: true,
    },
  },

  methods: {
    ...esigning_setup_route_methods,
    ...esigning_setup_workflow_methods,
    ...esigning_setup_form_methods,
  },
};
